module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00055-fs8.6fcbaf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00055-fs8.png
// module id = 208
// module chunks = 0